export function SectionEyebrow({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <p
      className={`text-[11px] font-medium uppercase tracking-[0.22em] text-pink-soft/90 mb-4 ${className}`}
    >
      {children}
    </p>
  );
}
